{
  "id": "campaign-120",
  "name": "Hedge Maze",
  "seed": "campaign:120",
  "generatorVersion": 3,
  "level": 120,
  "biome": "estate",
  "startDir": "N",
  "mowerRule": {
    "kind": "only",
    "mowers": ["reel", "push", "selfPropelled", "tractor", "zeroTurn"]
  },
  "rows": [
    "...............M...",
    ".M.M.MMMMMMMMM.M.M.",
    "...M...M...........",
    "MMMMMM.M.M.MMMMMMM.",
    ".........M.........",
    ".MMMMMMMMMMMMM.MMM.",
    ".......M.....M...M.",
    ".MMMMM.M.M.M.M.M.M.",
    ".M...M.....M.M.....",
    ".M.M.MMMMMMM.MMMMM.",
    ".....M.....M...M...",
    "MM.MMM.MMM.M.M.M.MM",
    "...M.....M.M.M.M...",
    ".MMM.MMM.M.M.M.MMM.",
    ".M...M...M.M.....M.",
    ".M.M.M.M.M.MMMMM.M.",
    "...M.M.M.M.......M.",
    ".MMM.M.M.MMMMMMMMM.",
    ".M...M.M.....M...M.",
    ".M.M.M.MMM.M.M.M.M.",
    ".M.M.....M...M.M...",
    ".M.MMMMM.M.MMM.MMM.",
    "S........M........."
  ],
  "pickups": [
    {
      "kind": "coin",
      "x": 13,
      "y": 22
    },
    {
      "kind": "coin",
      "x": 14,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 14,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 18
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 21
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 16
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 10
    },
    {
      "kind": "gas",
      "x": 10,
      "y": 14
    },
    {
      "kind": "gas",
      "x": 14,
      "y": 20
    }
  ],
  "critters": [],
  "party": {
    "tiles": 509
  },
  "par": {
    "reel": 11010,
    "push": 10166,
    "selfPropelled": 9384,
    "tractor": 7820,
    "zeroTurn": 6205
  }
}
